<template>
  <div class="trial-page">
    <div class="page-container">
      <div class="user-center">
        <user-center-sidebar active="trial" :user-info="userInfo"></user-center-sidebar>

        <!-- 主内容区 -->
        <section class="user-main">
          <!-- 统计卡片 -->
          <div class="stats-grid">
            <div class="stat-card">
              <div class="stat-icon"><i class="el-icon-s-promotion"></i></div>
              <div>
                <div class="stat-num">{{ trials.length }}</div>
                <div class="stat-label">申请总数</div>
              </div>
            </div>
            <div class="stat-card">
              <div class="stat-icon"><i class="el-icon-time"></i></div>
              <div>
                <div class="stat-num">{{ pendingCount }}</div>
                <div class="stat-label">待审核</div>
              </div>
            </div>
            <div class="stat-card">
              <div class="stat-icon"><i class="el-icon-circle-check"></i></div>
              <div>
                <div class="stat-num">{{ approvedCount }}</div>
                <div class="stat-label">已通过</div>
              </div>
            </div>
          </div>

          <!-- 申请表单 -->
          <div class="user-card">
            <div class="card-title">
              <h2>提交新申请</h2>
              <span class="extra">带 * 为必填</span>
            </div>
            <el-form :model="form" :rules="rules" ref="form" class="trial-form">
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="申请产品" prop="product">
                    <el-select v-model="form.product"
                               placeholder="请选择要试用的产品"
                               style="width: 100%">
                      <el-option v-for="(item, i) in appList"
                                 :key="i"
                                 :label="item.name"
                                 :value="item.name"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="公司名称" prop="name">
                    <el-input v-model="form.name" placeholder="例：海平创新科技有限公司"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="联系人" prop="contacts">
                    <el-input v-model="form.contacts"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="联系电话" prop="telephone">
                    <el-input v-model="form.telephone" maxlength="11" placeholder="11位手机号"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row>
                <el-col :span="24">
                  <el-form-item label="使用场景/申请说明">
                    <el-input
                      v-model="form.reason"
                      type="textarea"
                      :rows="4"
                      placeholder="请简要描述您的业务场景、当前痛点、想要解决什么问题。&#10;例如：现有客户背景调查主要依赖人工，效率低，希望批量校验工商/司法/行政处罚等。"
                    ></el-input>
                    <div class="form-tip">信息越详细，越有助于我们为您准备更合适的演示方案</div>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-form-item>
                <div class="form-actions">
                  <el-button type="primary" @click="handleSubmit" :loading="loading">
                    <i class="el-icon-s-promotion"></i> 提交申请
                  </el-button>
                  <el-button @click="handleReset">清空</el-button>
                </div>
              </el-form-item>
            </el-form>
          </div>

          <!-- 我的申请记录 -->
          <div class="user-card">
            <div class="card-title">
              <h2>我的申请记录</h2>
              <span class="extra">实时同步，最新申请置顶</span>
            </div>
            <div class="trial-list" v-if="trials.length > 0">
              <div class="trial-item" v-for="trial in trials" :key="trial.id">
                <div class="trial-badge" :class="trial.status">
                  <i :class="getStatusIcon(trial.status)"></i>
                </div>
                <div class="trial-meta">
                  <div class="trial-top">
                    <span class="trial-name">{{ trial.product }}</span>
                    <el-tag :type="getStatusType(trial.status)" size="small">
                      {{ getStatusText(trial.status) }}
                    </el-tag>
                  </div>
                  <div class="trial-info">
                    {{ trial.name }} · 联系人 {{trial.contacts}}
                    · 联系电话 {{ trial.telephone }}
                    · 提交于 {{ formatTime(trial.createTime) }}
                  </div>
                  <div class="trial-reason" v-if="trial.reason">
                    {{ trial.reason.length > 80 ? trial.reason.slice(0, 80) + '...' : trial.reason }}
                  </div>
                </div>
              </div>
            </div>
            <div class="empty" v-else>
              <i class="el-icon-inbox"></i> 暂无申请记录
            </div>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getCurrentUser,
  formatTime,
  validMobile
} from '@/utils/auth'
import { appList } from '../utils/optionData'
import UserCenterSidebar from '@/components/UserCenterSidebar'

export default {
  name: 'Trial',
  components: {
    UserCenterSidebar
  },
  data () {
    const validateContact = (rule, value, callback) => {
      if (value && !validMobile(value)) {
        callback(new Error('请输入正确的11位手机号'))
      } else {
        callback()
      }
    }
    return {
      appList,
      userInfo: {},
      trials: [],
      loading: false,
      form: {
        product: '',
        name: '',
        contacts: '',
        telephone: '',
        reason: ''
      },
      rules: {
        product: [
          { required: true, message: '请选择申请产品', trigger: 'change' }
        ],
        name: [
          { required: true, message: '请输入公司名称', trigger: 'blur' }
        ],
        contacts: [
          { required: true, message: '请输入联系人名称', trigger: 'blur' }
        ],
        telephone: [
          { validator: validateContact, trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    pendingCount () {
      return this.trials.filter(t => t.status === 'pending').length
    },
    approvedCount () {
      return this.trials.filter(t => t.status === 'approved').length
    }
  },
  created () {
    this.$bus.$on('login-success', this.handleLoginSuccess)
    if (!this.checkLogin()) return
    this.loadData()
  },
  methods: {
    checkLogin () {
      const user = getCurrentUser()
      if (!user) {
        this.$bus.$emit('open-login')
        return false
      }
      this.userInfo = user
      this.form.telephone = user.mobile || ''
      this.form.contacts = user.username || ''
      return true
    },
    handleLoginSuccess () {
      if (!getCurrentUser()) return
      this.checkLogin()
      this.loadData()
    },
    loadData () {
      this.$http({
        url: this.$http.adornUrl('/crmapi/crm/clue/clueList'),
        method: 'post',
        data: {
          pageNum: 1,
          pageSize: 100,
          data: this.userInfo.mobile ? { telephone: this.userInfo.mobile } : {}
        }
      }).then(({ data }) => {
        if (data && data.code === 'C0000') {
          const result = data.result || {}
          const list = result.list || []
          this.trials = list
            .map(item => this.mapClue(item))
            .sort((a, b) => new Date(b.createTime) - new Date(a.createTime))
        } else {
          this.$message.error((data && data.message) || '获取申请记录失败')
        }
      }).catch(() => {
        this.$message.error('获取申请记录失败')
      })
    },
    mapClue (clue) {
      const desc = clue.desc || ''
      const match = desc.match(/^【(.+?)】/)
      const product = match ? match[1] : ''
      const reason = match ? desc.slice(match[0].length) : desc
      return {
        id: clue.id,
        product,
        name: clue.name,
        contacts: clue.contacts,
        telephone: clue.telephone,
        createTime: clue.createTime,
        reason,
        status: this.mapStatus(clue.status)
      }
    },
    mapStatus (status) {
      // CRM 线索状态：1未分配 2已分配 3跟进中 4已转换 5无效 6已作废
      if (status === 4) return 'approved'
      if (status === 5 || status === 6) return 'rejected'
      return 'pending'
    },
    formatTime (time) {
      return formatTime(time)
    },
    formatDateTime (time) {
      if (!time) return '--'
      return time.replace('T', ' ')
    },
    getStatusText (status) {
      const map = {
        pending: '待审核',
        approved: '已通过',
        rejected: '已驳回'
      }
      return map[status] || '待审核'
    },
    getStatusType (status) {
      const map = {
        pending: 'warning',
        approved: 'success',
        rejected: 'danger'
      }
      return map[status] || 'info'
    },
    getStatusIcon (status) {
      return status === 'approved'
        ? 'el-icon-circle-check'
        : status === 'rejected'
          ? 'el-icon-circle-close'
          : 'el-icon-time'
    },
    handleSubmit () {
      this.$refs.form.validate(valid => {
        if (!valid) return

        this.loading = true
        this.$http({
          url: this.$http.adornUrl('/crmapi/crm/clue/add'),
          method: 'post',
          data: {
            name: this.form.name,
            contacts: this.form.contacts,
            telephone: this.form.telephone,
            desc: `【${this.form.product}】${this.form.reason}`
          }
        }).then(({ data }) => {
          if (data && data.code === 'C0000') {
            this.$message.success(data.message || '申请已提交，我们会尽快与您联系')
            this.handleReset()
            this.loadData()
          } else {
            this.$message.error((data && data.message) || '提交失败')
          }
        }).catch(() => {
          this.$message.error('提交失败，请稍后重试')
        }).finally(() => {
          this.loading = false
        })
      })
    },
    handleReset () {
      this.$refs.form.resetFields()
      this.form.telephone = this.userInfo.mobile || ''
      this.form.contacts = this.userInfo.username || ''
    }
  },
  beforeDestroy () {
    this.$bus.$off('login-success', this.handleLoginSuccess)
  }
}
</script>

<style lang="scss" scoped>
.trial-page {
  min-height: 100vh;
  background: #f5f7fa;
  padding: 20px;
}

.page-container {
  max-width: 1200px;
  margin: 0 auto;
}

.user-center {
  display: flex;
  gap: 20px;
}

.user-main {
  flex: 1;
}

.stats-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
  margin-bottom: 20px;

  .stat-card {
    background: #fff;
    border-radius: 12px;
    padding: 24px;
    display: flex;
    align-items: center;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);

    .stat-icon {
      width: 48px;
      height: 48px;
      background: linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%);
      border-radius: 12px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: 16px;

      i {
        font-size: 24px;
        color: #2196f3;
      }
    }

    .stat-num {
      font-size: 24px;
      font-weight: 600;
      color: #333;
    }

    .stat-label {
      font-size: 13px;
      color: #999;
    }
  }
}

.user-card {
  background: #fff;
  border-radius: 12px;
  margin-bottom: 20px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);

  .card-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px 24px;
    border-bottom: 1px solid #f0f0f0;

    h2 {
      font-size: 16px;
      color: #333;
      margin: 0;
    }

    .extra {
      font-size: 13px;
      color: #999;
    }
  }
}

.trial-form {
  padding: 24px;

  .form-tip {
    font-size: 12px;
    color: #999;
    margin-top: 4px;
  }

  .form-actions {
    display: flex;
    gap: 12px;
  }
}

.trial-list {
  padding: 8px 24px 16px;

  .trial-item {
    display: flex;
    align-items: flex-start;
    padding: 16px 0;
    border-bottom: 1px solid #f5f5f5;

    &:last-child {
      border-bottom: none;
    }

    .trial-badge {
      width: 40px;
      height: 40px;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: 16px;
      flex-shrink: 0;

      &.pending {
        background: #fff3e0;
        i { color: #ff9800; }
      }

      &.approved {
        background: #e8f5e9;
        i { color: #4caf50; }
      }

      &.rejected {
        background: #ffebee;
        i { color: #f44336; }
      }

      i {
        font-size: 20px;
      }
    }

    .trial-meta {
      flex: 1;
      min-width: 0;

      .trial-top {
        display: flex;
        align-items: center;
        gap: 10px;
        margin-bottom: 8px;

        .trial-name {
          font-size: 15px;
          color: #333;
          font-weight: 500;
        }
      }

      .trial-info {
        font-size: 13px;
        color: #999;
        margin-bottom: 6px;
      }

      .trial-reason {
        font-size: 13px;
        color: #666;
        line-height: 1.5;
      }
    }

    .trial-actions {
      flex-shrink: 0;
      margin-left: 16px;
    }
  }
}

.empty {
  text-align: center;
  padding: 40px 0;
  color: #999;
  font-size: 14px;

  i {
    font-size: 40px;
    color: #ddd;
    display: block;
    margin-bottom: 12px;
  }
}

@media screen and (max-width: 768px) {
  .user-center {
    flex-direction: column;
  }

  .stats-grid {
    grid-template-columns: 1fr;
  }

  .trial-form .el-row {
    .el-col {
      margin-bottom: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/trial.vue